var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWingspanOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7417 13.8755L20.4562 7.7424L24.0507 1.03287H30.6213L23.7417 13.8755ZM16.0001 13.8756L12.7149 7.74243L16.0001 1.60931L19.2856 7.74243L16.0001 13.8756ZM8.25878 13.8755L1.37918 1.03287H7.9498L11.5439 7.7424L8.25878 13.8755ZM23.287 0.272668L19.871 6.64953L16.4548 0.272668C16.3652 0.105198 16.1903 0.000366211 16.0001 0.000366211C15.8099 0.000366211 15.6353 0.105198 15.5454 0.272668L12.1294 6.64953L8.71349 0.272668C8.62359 0.105198 8.44898 0.000366211 8.25879 0.000366211H0.516522C0.126731 0.000366211 -0.122203 0.416446 0.0618197 0.76015L7.80376 15.2119C7.89366 15.3797 8.06827 15.4842 8.25879 15.4842C8.44898 15.4842 8.62359 15.3797 8.71349 15.2119L12.1294 8.83508L15.5454 15.2119C15.6353 15.3797 15.8099 15.4842 16.0001 15.4842C16.1903 15.4842 16.3652 15.3797 16.4548 15.2119L19.871 8.83508L23.287 15.2119C23.3766 15.3797 23.5515 15.4842 23.7417 15.4842C23.9319 15.4842 24.1068 15.3797 24.1964 15.2119L31.938 0.76015C32.1224 0.416446 31.8734 0.000366211 31.4833 0.000366211H23.7417C23.5515 0.000366211 23.3766 0.105198 23.287 0.272668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWingspanOutline);
export default __webpack_public_path__ + "static/media/Wingspan_Outline.5e26d86420d1170dfe923fe63c4e2f04.svg";
export { ForwardRef as ReactComponent };